export enum NewsFilterField {
  Private = 'Pcw',
  Location = 'Location',
  StartDate = 'StartDate',
  EndDate = 'EndDate',
  SectorIndustry = 'Industry',
  NewsType = 'NewsType',
  StoryType = 'StoryType',
}
